<template>
  <v-app-bar color="primary" elevation="1" app>
    <v-btn
      class=" text-capitalize"
      @click="$router.back()"
      v-if="showBackBtn"
      style="left: 25px;"
      absolute
      small
      icon
      dark
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
    <v-img class="mr-2" src="@/assets/logo.png" max-width="35px" v-if="$route.name === 'Home'"></v-img>
    <span class="white--text">
      {{ title }}
    </span>
    <v-spacer></v-spacer>
    <v-btn
      @click="$router.push({ name: 'Home' })"
      v-if="$route.name !== 'Home'"
      style="right: 25px"
      absolute
      small
      icon
      dark
    >
      <v-icon>mdi-home</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name: "TheAppBar",
  data() {
    return {};
  },
  computed: {
    title() {
      return this.$route.meta.appBarTitle || "TSVS 台灣血管外科學會";
    },
    showBackBtn() {
      if (this.$route.meta.backBtn == null) return true;
      return this.$route.meta.backBtn;
    }
  }
};
</script>

<style></style>
